// extracted by mini-css-extract-plugin
module.exports = {"container":"nwvao","checkbox":"_1z0bs","label":"_1XLgA","disabled":"_3YBpz","border":"_3tqqQ","checked":"_1Y7wc"};